module.exports = __webpack_public_path__ + "static/media/Addresses_84BaithaksOfShriMahaprabhuJi.954764f4.pdf";